import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useState } from "react";
import { LineChart } from "../../../charts/BarChart";
import { Venda } from "../../../models/venda";
import { DashPanel } from "../DashPanel";

export interface PanelAbasPorHoraProps {
  abasPorHora: Venda[];
  comparativo: Venda[];
  dateLabel: string;
  compareDateLabel: string;
}

export const PanelAbasPorHora = (props: PanelAbasPorHoraProps) => {
  const [medida, setMedida] = useState('quantidade');

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setMedida(event.target.value as string);
  }

  const getItemComparativo = (codigo: number) => {
    return props.comparativo?.find(c => c.codigo === codigo);
  }

  const dados = props.abasPorHora.map(x => {
    const compareItem = getItemComparativo(x.codigo);
    return { name: x.nome, value: x[medida], compareValue: compareItem ? compareItem[medida] : undefined }
  });

  return <DashPanel
    title="Abastecimentos por Hora"
    headerAction={
      <div>
        <FormControl style={{ paddingRight: '16px' }}>
          <InputLabel id="label-select-medida">Medida</InputLabel>
          <Select
            labelId="label-select-medida"
            id="select-medida"
            value={medida}
            onChange={handleSelectChange}
          >
            <MenuItem value={'quantidade'}>Litros</MenuItem>
            <MenuItem value={'total'}>Valor R$</MenuItem>
            <MenuItem value={'contagem'}>Contagem</MenuItem>
          </Select>
        </FormControl>
      </div>
    }>
    <LineChart label={props.dateLabel} compareLabel={props.compareDateLabel} dados={dados} />
  </DashPanel>;
}
